// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RestaurantFilters_wrapper__mdlAH","divider":"RestaurantFilters_divider__C9KFV","skeleton":"RestaurantFilters_skeleton__StcdL"};